import type { GameState } from "@/interfaces/vidyaGrid";
import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from "./shadcn/dialog";
import { Button } from "./shadcn/Button";

interface GamerOverDialogProps {
  gameState: GameState;
  resetGame: () => void;
}

const gameLostMessages = [
  "You lose! :(",
  "Game over",
  "Mission failed! We'll get them next time",
  "Your win is in another game",
  "DEAD END",
  "FALL OUT",
  "You died. However, the VidyaGrid traps you. You shall remain in this world as a Soul, forever.",
  "Acta est fabula",
  "All your base are belong to us",
  "With this VidyaGrid's loss, the thread of prophecy is severed. Restore the VidyaGrid to restore the weave of fate, or persist in the doomed game you have created.",
];

const gameWonMessages = [
  "YAY! You won!",
  "Mission accomplished",
  "The game was won. You shall obtain the Demon Soul... and a power that is beyond human imagination.",
  "You're winner!",
  "With this VidyaGrid's win, you no longer bear the burden of prophecy.",
  "You won! Congratulations!",
];

export default function GamerOverDialog({
  gameState,
  resetGame,
}: GamerOverDialogProps) {
  const [showModal, setShowModal] = useState(true);
  const [modalInfo, setModalInfo] = useState({
    title: "",
    subtitle: "",
    color: "text-white",
  });

  useEffect(() => {
    const pickRandomMessage = (array: string[]) =>
      array[Math.floor(Math.random() * array.length)];

    if (gameState === "won") {
      setModalInfo({
        title: "WIN",
        subtitle: pickRandomMessage(gameWonMessages),
        color: "text-green-500",
      });
    } else if (gameState === "lost") {
      setModalInfo({
        title: "LOSE",
        subtitle: pickRandomMessage(gameLostMessages),
        color: "text-red-500",
      });
    }
  }, [gameState]);

  if (gameState === "playing") return null;

  return (
    <Dialog
      open={showModal}
      onOpenChange={() => {
        if (gameState === "won") setShowModal(false);
      }}
    >
      <DialogContent className="grid">
        <DialogHeader className={modalInfo.color}>
          <DialogTitle className="scroll-m-20 pb-2 text-2xl font-semibold tracking-tight first:mt-0">
            {modalInfo.title}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="scroll-m-20 text-xl font-semibold tracking-tight">
          {modalInfo.subtitle}
        </DialogDescription>
        {gameState === "lost" && (
          <Button className="mt-6" onClick={resetGame}>
            New game
          </Button>
        )}
      </DialogContent>
    </Dialog>
  );
}
